
import { Vue, Component } from 'vue-property-decorator';
import LandingWrapper from "../components/LandingWrapper.vue";
import PrivacyPolicyContent from "../components/PrivacyPolicyContent.vue";

    @Component({ name: 'PrivacyPolicy', components: { LandingWrapper, PrivacyPolicyContent } })
export default class PrivacyPolicy extends Vue {

}
